/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_SizeInputs */

const en_field_size = /** @type {(inputs: Field_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size`)
};

const es_field_size = /** @type {(inputs: Field_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talla/Tamaño`)
};

const fr_field_size = /** @type {(inputs: Field_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille`)
};

const de_field_size = /** @type {(inputs: Field_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe`)
};

const ja_field_size = /** @type {(inputs: Field_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイズ`)
};

const zh_field_size = /** @type {(inputs: Field_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尺寸`)
};

const ar_field_size = /** @type {(inputs: Field_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المقاس / الحجم`)
};

const id_field_size = /** @type {(inputs: Field_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukuran`)
};

const it_field_size = /** @type {(inputs: Field_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taglia/Dimensione`)
};

const ru_field_size = /** @type {(inputs: Field_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер`)
};

const pt_field_size = /** @type {(inputs: Field_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho`)
};

const ko_field_size = /** @type {(inputs: Field_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크기/사이즈`)
};

/**
* | output |
* | --- |
* | "Size" |
*
* @param {Field_SizeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_size = /** @type {((inputs?: Field_SizeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_SizeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_size(inputs)
	if (locale === "es") return es_field_size(inputs)
	if (locale === "fr") return fr_field_size(inputs)
	if (locale === "de") return de_field_size(inputs)
	if (locale === "ja") return ja_field_size(inputs)
	if (locale === "zh") return zh_field_size(inputs)
	if (locale === "ar") return ar_field_size(inputs)
	if (locale === "id") return id_field_size(inputs)
	if (locale === "it") return it_field_size(inputs)
	if (locale === "ru") return ru_field_size(inputs)
	if (locale === "pt") return pt_field_size(inputs)
	return ko_field_size(inputs)
});